import RelaySummaryRow from './RelaySummaryRow';
import Table from 'react-bootstrap/Table';

function SearchTable(props) {
  if (props.details) {
    return (
      <Table bordered hover size="sm">
        <thead>
          <tr>
            <th></th>
            <th>Nickname</th>
            <th>Up/Downtime</th>
            <th>Country</th>
            <th>Network</th>
            <th>Flags</th>
            <th>Advertised Bandwidth</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
        {props.details.relays.map((relay, index) => {
          return <RelaySummaryRow type="relay" key={relay.fingerprint} relay={relay} />
        })}
        {props.details.bridges.map((bridge, index) => {
          return <RelaySummaryRow type="bridge" key={bridge.hashed_fingerprint} relay={bridge} />
        })}
        </tbody>
      </Table>
    );
  }
}

export default SearchTable;
